var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c("div", { staticClass: "boss-main-content-wrap" }, [
      _c("section", [
        _c(
          "div",
          {
            staticClass:
              "boss-layout boss-layout-vertical boss-layout-vertical-gap-large",
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("Accordion", {
              staticClass: "pega-visible",
              attrs: { "is-open": _vm.isOpen },
              scopedSlots: _vm._u([
                {
                  key: "head",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            "送信対象者一覧（全" + _vm.entryIds.length + "名）"
                          ) +
                          "\n          "
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", [
                        _c("div", { staticClass: "boss-table-wrap" }, [
                          _c(
                            "table",
                            { staticClass: "boss-table-4" },
                            [
                              _c("tr", [
                                _c("th", [_vm._v("応募日")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("応募者")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("セミナー")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("メッセージ")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("ステータス")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("備考")]),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.entries, function (entry, i) {
                                return _c("seminar-entry-bulk-message-target", {
                                  key: i,
                                  attrs: { entry: entry },
                                })
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("seminar-entry-message-register", {
              attrs: { "entry-ids": _vm.entryIds },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "boss-page-title-layout" }, [
        _c("div", [
          _c(
            "h1",
            { staticClass: "boss-page-title boss-page-title-layout-title" },
            [
              _vm._v(
                "\n                セミナー応募者へメッセージを一括送信\n              "
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }